import { Clock, WeatherData, InframouraLogo } from "./TopBar/index";
//;
const TopBar = (props: any) => {
  return (
    <div className="TopBar">
      <WeatherData />
      <InframouraLogo />
      <Clock />
    </div>
  );
};

export default TopBar;
